import React from 'react'
import { constants } from 'common/helpers'

import s from './Description.scss'


const Description = ({ text, withMicrodata }) => (
  <div
    className={s.text}
    {...withMicrodata && { itemProp: 'description' }}
    data-testid={constants.testIds.review.message}
  >
    {text}
  </div>
)

export default Description
